import { NgModule } from '@angular/core';
import { OccupancyReportComponent } from './occupancy-report.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { StatisticsModule } from 'src/app/shared/statistics/statistics.module';
import { AppRoutingModule } from "src/app/app-routing.module";

@NgModule({
  declarations: [OccupancyReportComponent],
  imports: [SharedModule, StatisticsModule, AppRoutingModule],
  exports: [OccupancyReportComponent],
})
export class OccupancyReportModule {}
